import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";

function StatsAdmin() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      try {
        const response = await fetchWithAuth("/tracking/stats", {
          method: "GET",
        });
        const data = await response.json();
        setStats(data);
      } catch (error) {
        setStats([]);
      }
      setLoading(false);
    };
    fetchStats();
  }, []);

  const handleDelete = async (row) => {
    setDeleting(row._id);
    try {
      await fetchWithAuth("/tracking/delete", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ _id: row._id }),
      });
      setStats(stats.filter((s) => s._id !== row._id));
    } catch (e) {
      // Optionnel : afficher une erreur
    }
    setDeleting(null);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        Statistiques d'accès
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer
          component={Paper}
          sx={{ marginY: "24px", width: "100%", overflowX: "auto" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Utilisateur</TableCell>
                <TableCell>Plan</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stats.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} sx={{ textAlign: "center" }}>
                    Aucune donnée.
                  </TableCell>
                </TableRow>
              ) : (
                stats.map((row, idx) => (
                  <TableRow key={row._id}>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      {row.existsInUsers ? (
                        <CheckCircleIcon
                          color="success"
                          titleAccess="Utilisateur existant"
                        />
                      ) : (
                        <VisibilityIcon
                          color="disabled"
                          titleAccess="Utilisateur inconnu"
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      {row.existsInUsers && row.plan ? row.plan : "-"}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(row)}
                        disabled={deleting === row._id}
                        aria-label="Supprimer"
                        sx={{ minWidth: "40px" }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default StatsAdmin;
